import React from 'react';

import LoginCreds from '../../components/loginpages/LoginCreds';
import { TSPCategory, TSPConfig } from '../types';

const simbaEldConfig: TSPConfig = {
  key: 'simbaeld',
  name: 'Simba ELD',
  imageName: 'simbaeld',
  category: TSPCategory.CUSTOM,
  helpText:
    "Please input the company ID from your Simba ELD profile. It should start with 'Company:' (like 'Company:12345').",
  loginComponent: (props) => (
    <LoginCreds
      onValidityChange={props.onValidityChange}
      fields={[
        {
          label: 'Enter Simba ELD Company ID (e.g. Company:12345)',
          name: 'apikey',
          type: 'text',
          required: true,
        },
      ]}
    />
  ),
};

export default simbaEldConfig;
